import { render, staticRenderFns } from "./plan-detail.vue?vue&type=template&id=16f67c1b&scoped=true&"
import script from "./plan-detail.vue?vue&type=script&lang=js&"
export * from "./plan-detail.vue?vue&type=script&lang=js&"
import style0 from "./plan-detail.vue?vue&type=style&index=0&id=16f67c1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f67c1b",
  null
  
)

export default component.exports